import { useFeatureFlagsStore } from '@renderer/stores/featureFlagsStore'

/**
 * One switch for the camera connect/recovery rework of 2026-09-16.
 *
 * The work went to the fleet unflagged and caused a visible regression: switching the
 * primary camera joined the connect already in flight, so the new body never connected
 * while the UI showed it as connected. Everything from that night therefore sits behind
 * this single flag, allowlisted to one account, until it is proven on a real booth.
 *
 * OFF (every booth by default) must be byte-for-byte the pre-2026-09-16 behaviour. When
 * adding to this group, gate the NEW path and leave the old one exactly as it was —
 * never "improve" the off path at the same time.
 */
export const CAMERA_RECOVERY_FLAG = 'camera_recovery_v3'

export function isCameraRecoveryEnabled(): boolean {
  return useFeatureFlagsStore.getState().getFlag(CAMERA_RECOVERY_FLAG, false)
}
